import { Injectable, signal } from '@angular/core';
import { Stable } from '../types/stable.model';

@Injectable()
export class DefaultValuePayloadService {
  stable = signal<Stable | undefined>(undefined);
}
